import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CardHeader from "../Components/CardHeader";
import DataItem from "../Components/DataItem";
import SlideUpDialog from "../Layout/SlideUpDialog/SlideUpDialog";

const useStyles = makeStyles({
  root: {},
  title: {
    padding: 20,
    borderBottom: "1px solid #D8D8D8",
  },
  avatar: {
    width: 160,
    height: 160,
    marginTop: 40,
    border: "5px solid #3C85AB",
  },
});

const profile = {
  nome: "Franceschina",
  avatar: "",
  cognome: "Peppiniella",
  privilegi: "Amministratore",
  ruolo: "Consulente",
  azienda: "Enterprise Systems",
  badge: "02020242",
  telefono: "334923211",
  mail: "fra.bll@gmail.com",
  password: "*******",
};

export default function UserRightPanel(props) {
  const classes = useStyles();
  const [editSecurityData, setEditSecurityData] = useState(false);

  return (
    <Grid id="main" container className={classes.root}>
      <Grid
        container
        className={classes.title}
        alignItems="center"
        justify="space-between"
      >
        <IconButton
          color="inherit"
          aria-label="close"
          onClick={props.toggleDrawer("user", false)}
        >
          <ChevronRightIcon />
        </IconButton>
        <Typography variant="h2">Profilo Utente</Typography>
      </Grid>
      <Grid
        id="identity"
        container
        item
        justify="center"
        alignItems="center"
        direction="column"
      >
        <Grid item>
          <Avatar
            className={classes.avatar}
            src="https://source.unsplash.com/random/?portrait"
          ></Avatar>
        </Grid>
        <Grid
          container
          item
          justify="center"
          alignItems="center"
          direction="column"
        >
          <Typography
            variant="h5"
            style={{ fontWeight: 600, color: "#343434", marginTop: 20 }}
          >
            {profile.nome} {profile.cognome}
          </Typography>
          <Typography variant="body2">{profile.privilegi}</Typography>
        </Grid>
        <Grid id="person-data" container item style={{ padding: "30px 40px" }}>
          <Grid xs={4} container item alignItems="center" direction="column">
            <Typography variant="subtitle1">Azienda</Typography>
            <Typography variant="subtitle2">{profile.azienda}</Typography>
          </Grid>
          <Grid xs={4} container item alignItems="center" direction="column">
            <Typography variant="subtitle1">Ruolo</Typography>
            <Typography variant="subtitle2">{profile.ruolo}</Typography>
          </Grid>
          <Grid xs={4} container item alignItems="center" direction="column">
            <Typography variant="subtitle1">Badge</Typography>
            <Typography variant="subtitle2">{profile.badge}</Typography>
          </Grid>
          <Grid
            id="security-box"
            container
            item
            style={{
              background: "#f2f2f2",
              marginTop: 50,
              borderRadius: 10,
              padding: 30,
            }}
          >
            <CardHeader
              title="Dati di accesso"
              canEdit={true}
              actionClick={() => setEditSecurityData(true)}
            ></CardHeader>
            <DataItem
              title="Telefono:"
              data={profile.telefono}
              first={true}
            ></DataItem>
            <DataItem title="Mail:" data={profile.mail} first={true}></DataItem>
            <DataItem
              title="Password:"
              data={profile.password}
              first={true}
            ></DataItem>
          </Grid>
          <Grid container justify="flex-end" style={{ marginTop: 30 }}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => console.log("logout")}
            >
              Disconnetti Utente
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <SlideUpDialog
        title="Modifica Dati"
        open={editSecurityData}
        handleClose={() => setEditSecurityData(false)}
      >
        <DialogEditSecurityData data={profile} />
      </SlideUpDialog>
    </Grid>
  );
}

function DialogEditSecurityData(props) {
  const [state, setState] = useState({
    telefono: props.data.telefono,
    mail: props.data.mail,
    password: props.data.password,
  });

  function handleChange(evt) {
    const value = evt.target.value;
    setState({
      ...state,
      [evt.target.name]: value,
    });
  }
  return (
    <Grid
      container
      item
      xs={12}
      alignItems="center"
      spacing={2}
      style={{ marginTop: 20 }}
    >
      <Grid item xs={6}>
        <TextField
          key="telefono"
          label="Telefono"
          margin="normal"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          variant="outlined"
          name="telefono"
          value={state.telefono}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          key="mail"
          label="Mail"
          margin="normal"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          name="mail"
          variant="outlined"
          value={state.mail}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          key="oldPassword"
          label="Password Attuale"
          margin="normal"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          name="password"
          variant="outlined"
          value={state.password}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          key="newPassword"
          label="Nuova Password"
          margin="normal"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          name="password"
          variant="outlined"
          value={state.password}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          key="repeatNewPassword"
          label="Ripeti Nuova Password"
          margin="normal"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          name="password"
          variant="outlined"
          value={state.password}
          onChange={handleChange}
        />
      </Grid>

      <Grid container spacing={2} justify="flex-end" style={{ marginTop: 20 }}>
        <Grid item>
          <Button
            variant="outlined"
            color="secondary"
            onClick={props.handleClose}
          >
            Annulla
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={props.handleClose}
          >
            Salva
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}
